import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { freezeNoticeExpired } from '../../redux/gameSlice';
import './FreezeCenterNotice.css';

// How long the centered notice stays up before it self-expires.
const NOTICE_TTL_MS = 4000;

// Centered freeze-time notice for one table: the server rejected a queue pick with EXACTLY
// "already executed a queued freeze" (one queued freeze per round), and GameTable turned that
// into a freezeNoticeShown. Renders the blue-bordered pill dead-center of the table view for
// 4s, then dispatches its own expiry. One notice per room (a newer replaces the older —
// receivedAt keys the effect so the timer restarts).
const FreezeCenterNotice = ({ roomId }) => {
  const dispatch = useDispatch();
  const notice = useSelector((state) => state.games.freezeNotices[roomId]);

  useEffect(() => {
    if (!notice) return undefined;
    const remaining = Math.max(0, NOTICE_TTL_MS - (Date.now() - (notice.receivedAt || Date.now())));
    const t = setTimeout(() => dispatch(freezeNoticeExpired({ roomId })), remaining);
    return () => clearTimeout(t);
  }, [dispatch, roomId, notice]);

  if (!notice) return null;

  return (
    <div className="freeze-center-notice">
      <div className="freeze-center-notice-pill">{notice.text}</div>
    </div>
  );
};

export default FreezeCenterNotice;
